export async function fetchTimeline(dateStr) {
  const qs = dateStr ? `?date=${encodeURIComponent(String(dateStr))}` : '';
  const res = await fetch(`/api/timeline${qs}`, {
    cache: 'no-store',
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  });
  if (!res.ok) throw new Error('Failed to load timeline');
  return res.json();
}

async function readErrorText(response) {
  try {
    return await response.text();
  } catch {
    return '';
  }
}

export async function fetchWorkflows() {
  const response = await fetch('/api/workflows/', {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });

  if (!response.ok) {
    throw new Error('Failed to load workflows');
  }

  return response.json();
}

export async function fetchStarterTemplates() {
  const response = await fetch('/api/starter-templates/', {
    cache: 'no-store',
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });

  if (!response.ok) {
    throw new Error('Failed to load starter templates');
  }

  return response.json();
}

export async function importStarterTemplate(templateKey, payload = {}) {
  const response = await fetch(`/api/starter-templates/${encodeURIComponent(String(templateKey))}/import`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const details = await readErrorText(response);
    throw new Error(`${response.status}${details ? `: ${details}` : ''}`);
  }

  return response.json();
}

export async function fetchWorkflowDetail(workflowId) {
  const response = await fetch(`/api/workflows/${encodeURIComponent(String(workflowId))}`, {
    headers: { 'X-Requested-With': 'XMLHttpRequest' },
  });

  if (!response.ok) {
    throw new Error('Failed to load workflow detail');
  }

  return response.json();
}

export async function createDayWorkflow(payload) {
  const response = await fetch('/api/day-workflows/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const details = await readErrorText(response);
    throw new Error(`${response.status}${details ? `: ${details}` : ''}`);
  }

  return response.json();
}

export async function persistTimelineRowOrder(payload) {
  const response = await fetch('/api/timeline/row-order', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const details = await readErrorText(response);
    throw new Error(`${response.status}${details ? `: ${details}` : ''}`);
  }

  return response.json();
}

export async function shiftTimelineWorkflow(payload) {
  const response = await fetch('/api/timeline/shift-workflow', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const details = await readErrorText(response);
    throw new Error(`${response.status}${details ? `: ${details}` : ''}`);
  }

  return response.json();
}

export async function shiftTimelineWorkflows(payload) {
  const response = await fetch('/api/timeline/shift-workflows', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const details = await readErrorText(response);
    throw new Error(`${response.status}${details ? `: ${details}` : ''}`);
  }

  return response.json();
}

export async function shiftTimelineDay(payload) {
  const response = await fetch('/api/timeline/shift-day', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const details = await readErrorText(response);
    throw new Error(`${response.status}${details ? `: ${details}` : ''}`);
  }

  return response.json();
}
